import React, {useState, useMemo, useEffect} from 'react'
import styles from './styles.module.scss'
import closeModalImage from "../../../../components/PayModal/assets/CloseModalIcon.svg";
import Modal from "react-modal";
import branchApi from "../../../../store/branchStore/branchApi";
import {Roles} from "../../../../config";
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useCurrentBranch} from "../../../../hooks/useCurrentBranch";
import { store } from "react-notifications-component";
import Select from "react-dropdown-select";
import UploadImage from "../../../ClientsDatabaseSendNotifications/UploadImage";
import TextField from "../../../../components/FormElements/TextField";

const SendNotificationModal = (props) => {
  const { info } = useSelector(s => s.branchReducer);
  const profile = useSelector(s => s.profileReducer);
  const { branch_ids } = useSelector(s => s.filtersReducer);

  const { t, i18n } = useTranslation();
  const [modalPending, setModalPending] = useState(false);
  const [pushMessage, setPushMessage] = useState('')
  const [image, setImage] = useState(null)
  const [buttonLinks, setButtonLinks] = useState([
    { link: '', label: '' }
  ])
  const [type, setType] = useState({
    label: t('text'),
    value: 'text',
  })
  const { currentRole, currentBranch, groupId } = useCurrentBranch();
  const {
    chosenClients,
  } = useSelector(s => s.clientsReducer);

  const onChangePushMessage = (e) => {
    if (e.target.value.length <= 1200) {
      setPushMessage(e.target.value);
    }
  }

  const types = useMemo(() => {
    return [
      {
        label: t('text'),
        value: 'text',
      },
      {
        label: t('file'),
        value: 'file',
      },
      {
        label: t('button-links'),
        value: 'button-links',
      },
    ]
  }, [i18n.language])

  useEffect(() => {
    setImage(null)
    setButtonLinks([
      { link: '', label: '' }
    ])
  }, [type])

  const onSendPushToCustomers = (e) => {
    e.preventDefault();
    if (!info || !pushMessage) return

    if (!chosenClients.length) return

    setModalPending(true);
    if (currentRole === Roles.ADMINISTRATOR && groupId) {
      const formData = new FormData()
      formData.append('message', pushMessage)
      formData.append('type', type.value)
      
      // Add user_ids from chosen clients
      chosenClients.forEach(id => formData.append('user_ids', id))
      
      // Add branch_ids  
      const branchIdsList = branch_ids.length ? 
        branch_ids.map(({value}) => Number(value)) : 
        profile.info.branches.map(({id}) => id);
      branchIdsList.forEach(id => formData.append('branch_ids', id))

      if (type.value === 'file') {
        formData.append('image', image)
      }
      if (type.value === 'button-links') {
        buttonLinks.forEach(({ label }) => formData.append('button_labels', label))
        buttonLinks.forEach(({ link }) => formData.append('button_urls', link))
      }

      branchApi.branchesAnalyticCustomersUploadedSend(groupId, formData)
          .then((res) => {
            store.addNotification({
              title: t('success'),
              message: t('successMessageSent'),
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: {
                duration: 5000,
                onScreen: true
              }
            });
            setPushMessage('');
            setButtonLinks([{label: '', link: ''}]);
            setImage(null);
            setType({
              label: t('text'),
              value: 'text',
            });
          })
          .finally(() => {
            setModalPending(false);
            props.onRequestClose();
          });
    } else {
      // For non-analytic roles, also use FormData
      const formData = new FormData()
      formData.append('message', pushMessage)
      formData.append('type', type.value)
      
      // Add user_ids from chosen clients
      chosenClients.forEach(id => formData.append('user_ids', id))
      formData.append('branch_ids', info.id)

      if (type.value === 'file') {
        formData.append('image', image)
      }
      if (type.value === 'button-links') {
        buttonLinks.forEach(({ label }) => formData.append('button_labels', label))
        buttonLinks.forEach(({ link }) => formData.append('button_urls', link))
      }

      branchApi.branchesCustomersUploadedSend(info.id, formData)
          .then((res) => {
            store.addNotification({
              title: t('success'),
              message: t('successMessageSent'),
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: {
                duration: 5000,
                onScreen: true
              }
            });
            setPushMessage('');
            setButtonLinks([{label: '', link: ''}]);
            setImage(null);
            setType({
              label: t('text'),
              value: 'text',
            });
          })
          .finally(() => {
            setModalPending(false);
            props.onRequestClose();
          });
    }
  }

  return (
    <Modal
      {...props}
    >
      <div className={styles.modal}>
        <div className={styles.closeModal} onClick={props.onRequestClose}>
          <img src={closeModalImage}/>
        </div>
        <div className={styles.leftContent}>
          <div className={styles.modalContainer}>
            <div className={styles.header}>
              <p>{t('NSClients.not')}</p>
            </div>

            <Select
              placeholder={t('chooseType')}
              values={[type]}
              options={types}
              onChange={(values) => setType(values[0])}
              style={{ 
                height: 42, 
                border: '1px solid #E7E7E6', 
                borderRadius: '5px', 
                marginBottom: '1rem' 
              }}
            />

            <form onSubmit={onSendPushToCustomers}>
              <div>
                <p className={styles.p}>{t('NSClients.textNot')}</p>
                <textarea
                  placeholder={t('Form.enterText')}
                  className={styles.textArea}
                  value={pushMessage}
                  onChange={onChangePushMessage}
                  required
                />
                <div className={styles.span}
                     style={{color: `${pushMessage.length >= 1199 ? 'tomato' : '#000000'}`}}>
                  {t('maxSym', {sym: 1200})}
                </div>

                {type.value === 'file' && (
                  <div className={styles.fileUploadSection}>
                    <UploadImage
                      onChange={(image) => setImage(image)}
                      image={image}
                    />
                  </div>
                )}

                {type.value === 'button-links' && (
                  <div className={styles.buttonLinksSection}>
                    {buttonLinks.length < 3 && (
                      <ButtonFilled
                        type="button"
                        onClick={() => setButtonLinks([...buttonLinks, { link: '', label: '' }])}
                        className={styles.addLinkBtn}
                      >
                        {t('addLink')}
                      </ButtonFilled>
                    )}
                    {buttonLinks.map((item, index) => (
                      <div key={index} className={styles.linkGroup}>
                        <div>
                          <TextField
                            label={t('title')}
                            required
                            value={item.label}
                            onChange={(e) => {
                              if (e.target.value.length <= 25) {
                                setButtonLinks(
                                  buttonLinks.map((i, idx) => idx === index ? { ...i, label: e.target.value } : i)
                                )
                              }
                            }}
                          />
                        </div>
                        <div>
                          <TextField
                            label={t('link')}
                            type="url"
                            required
                            value={item.link}
                            onChange={(e) => {
                              setButtonLinks(
                                buttonLinks.map((i, idx) => idx === index ? { ...i, link: e.target.value } : i)
                              )
                            }}
                          />
                        </div>
                        {index > 0 && (
                          <ButtonFilled
                            type="button"
                            variant="red"
                            onClick={() => setButtonLinks(buttonLinks.filter((i, idx) => idx !== index))}
                            className={styles.deleteLinkBtn}
                          >
                            {t('delete')}
                          </ButtonFilled>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                <div className={styles.buttonGroup}>
                  <ButtonFilled
                    type="submit"
                    className={styles.btn}
                    disabled={(!chosenClients.length) || !pushMessage || !profile?.info?.branches || 
                      (type.value === 'file' && !image) ||
                      (type.value === 'button-links' && (!buttonLinks.every(link => link.label && link.link)))
                    }
                    loading={modalPending}
                  >
                    {t('send')}
                  </ButtonFilled>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default SendNotificationModal